module.exports = __webpack_public_path__ + "img/quick_nav2.9ef4cdc8.png";